import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./klass.VuwRadioField";

/**
 * VuwCheckboxField (extends VuwRadioField)
 * @options
 * - {Boolean} required
 * - {Number} ltd
 * - {Array | Object} dataOption
 */

vuwer.appendKlass("VuwCheckboxField", {
	inpType: "checkbox",
	inpClassList: ["inp", "inp-checkbox"],
	
	_initialize(opt) {
		const _super_ = Klass("VuwCheckboxField").parent._initialize.bind(this);
		if( _super_(opt) ) {
			// [バリデーションの上書き]
			// 必須
			this._validations.required = val => !this.required || !!val.length;
			this.errorMessages.required = this.errorMessages.required.replace(/^いずれかを/, "１つ以上");
			
			// [バリデーションの登録]
			// 選択数制限
			this.addValidation("ltd", val => {
				return !u_.isNumber(this.ltd) || val.length <= this.ltd;
			}, this.ltd ? `${this.ltd}つまで選択可能です` : "");
			
			// [ltd の動的な切り替え用]
			this.onChangeState(state => {
				if( u_.hasProperty(state, "ltd") ) {
					if( u_.isNumber(state.ltd) && state.ltd > 0) {
						this.ltd = state.ltd;
						this.errorMessages.ltd = `${this.ltd}つまで選択可能です`;
					}
					delete state.ltd;
				}
			});
			
			return this;
			
		} else {
			return false;
		}
	},
	
	setVal(value, isChecked, antiTriggerChange) {
		(typeof isChecked === "boolean") || (isChecked = true);
		let $trigger;
		if(this.$inp.length) {
			if( Array.isArray(value) ) {
				if(isChecked) {
					// 一旦すべて未選択にする
					this.$inp.prop("checked", false);
				}
				
				if(value.length) {
					value = value.map((val, i) => {
						const $inp = this.getInpElm(val);
						if($inp.length) {
							if(isChecked) {
								if(!antiTriggerChange) {
									$inp.prop("checked", true);
									$trigger = !!$trigger ? $trigger.add( $inp.prop("checked", true) ) : $inp;
								}
								
								return $inp.val();
							}
							
							// [not isChecked]
							if( !$inp.prop("checked") ) {
								return $inp.val();
							}
							
							if(!antiTriggerChange) {
								$trigger = !!$trigger ? $trigger.add( $inp.prop("checked", true) ) : $inp;
							}
						}
					});
					
				} else
				if(isChecked && !antiTriggerChange) {
					$trigger = this.$inp;
				}
				
			} else {
				const $inp = this.getInpElm(value);
				if($inp && $inp.length) {
					!antiTriggerChange && ( $trigger = $inp.prop("checked", isChecked) );
					value = this.getVal();
					Array.isArray(value) || (value = []);
					
					if(isChecked) {
						value.push( $inp.val() );
						
					} else {
						$inp.idx = value.indexOf( $inp.val() );
						($inp.idx >= 0) && value.splice($inp.idx, 1);
					}
					
				} else {
					// clear value
					!antiTriggerChange && ( $trigger = this.$inp.prop("checked", false) );
					value = [];
				}
			}
		}
		
		if( Array.isArray(value) ) {
			const values = [];
			if(value.length) {
				// dataOption順の配列に変換
				const keys = Object.keys(this.dataOption);
				const len = keys.length;
				for(let i = 0; i < len; i++) {
					const k = keys[i];
					if(value.indexOf(k) >= 0) {
						values.push(k);
					}
				}
			}
			
			Klass("VuwField").prototype.setVal.call(this, values);
		}
		
		!!$trigger && $trigger.trigger("change", [true]);
		return this;
	},
	
	getVal() {
		return Klass("VuwField").prototype.getVal.call(this);
	},
	
	_getCopiedInp(val) {
		const clones = [];
		
		(val === undefined) && ( val = this.getVal() );
		
		if(Array.isArray(val) && val.length) {
			val.forEach(v => {
				const $lbl = this.$self.find(`input[value='${v}']`).next("label");
				!!$lbl.length && clones.push( $("<fieldset/>").append(
					$lbl.clone().addClass("replaced-inp").attr({
						"for": "",
						"data-value": v
					})
				) );
			});
		}
		return clones;
	},
	
	_renderField() {
		const _super_ = Klass("VuwCheckboxField").parent._renderField.bind(this);
		const $field = _super_();
		if($field instanceof $ && $field.length) {
			$field.find(".inp-checkbox").attr("name", `${this.paramKey}[]`);
		}
		return $field;
	}
}, "VuwRadioField");
